<template>
  <div id="hrms76x">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms76xIndex"
            :columnEvent="columnEvent"
            :csvExportDisp="true"
            searchBoxAlias="hrms76x"
            :callSearchEvent="callSearchEvent" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms76x/mutation-types'
import moment from 'moment'

export default {
  name: 'hrms76x',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      searchIndex: {}
    }
  },
  created () {
    this.receivedHrms76xColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS76X_INDEX_DISP,
      columns: types.GET_HRMS76X_COLUMNS,
      labels: types.GET_HRMS76X_LABELS,
      index: types.GET_HRMS76X_INDEX
    })
  },
  methods: {
    callSearchEvent () {
      if (this.searchIndex.codempid3 !== '') {
        this.searchIndex.codcomp = ''
        this.searchIndex.codpos = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS76X_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS76X_PAGE,
      receivedHrms76xColumnsLabels: types.RECEIVED_HRMS76X_COLUMNS_LABELS,
      receivedHrms76xIndex: types.RECEIVED_HRMS76X_INDEX
    })
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?555dfe08